import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import DepartmentCard from "./components/DepartmentCard";
import FilterSection from "./components/FilterSection";

const Departments = () => {
  const [filters, setFilters] = useState({
    category: "all",
    duration: "all",
    level: "all",
    search: "",
  });
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [filteredDepartments, setFilteredDepartments] = useState([]);

  // Mock departments data
  const departments = [
    {
      id: 1,
      name: "Computing Informatics & Business",
      category: "CIB",
      duration: "Level 4, 5 & 6",
      level: "iv",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      icon: "Monitor",
      description:
        "Comprehensive program covering software development, Cybersecurity, Networking, Business Administration and emerging technologies.",
      fullDescription: `Our programs are designed to prepare students for the rapidly evolving technical industry. The curriculum covers fundamentals concepts, database management, web development, mobile app development, and cybersecurity.\n\nStudents gain hands-on experience through real-world projects, internships with leading tech companies, and collaborative research opportunities. Our state-of-the-art computer labs are equipped with the latest hardware and software tools used in the industry.`,
      keyFeatures: [
        "Industry-Standard Programming Languages",
        "AI & Machine Learning Labs",
        "Cloud Computing Infrastructure",
        "Cybersecurity Training",
        "Mobile App Development",
        "Web Development Frameworks",
        "Database Management Systems",
        "Software Engineering Practices",
      ],
      facultyHighlights: [
        {
          name: "Mr. James Kirimi",
          expertise: "HoD Computing Informatics and Business",
          photo: "/assets/images/hod-computing.jpg",
        },
      ],
      labEquipment: [
        "High-Performance Computing Clusters",
        "Latest Generation Workstations",
        "Cloud Computing Infrastructure",
        "AI/ML Development Platforms",
      ],
    },
    {
      id: 2,
      name: "Building & Civil Engineering",
      category: "BCE",
      duration: "Level 4, 5 & 6",
      level: "Diploma",
      image: "/assets/images/Trainees_in_Carpentry1-min.JPG",
      icon: "Wrench",
      description:
        "Advanced building and civil engineering programmes with focus on design, and automation technologies.",
      fullDescription: `The Civil Engineering program at KTTI combines traditional principles with cutting-edge technology. Students learn design engineering, and materials science.\n\nOur curriculum emphasizes practical learning through well-equipped workshops, CAD/CAM labs, and industry partnerships. Students work on real-world projects including structural designs`,
      keyFeatures: [
        "CAD/CAM Design Labs",
        "CNC Machining Centers",
        "Robotics & Automation",
        "Materials Testing Lab",
        "Thermal Engineering Lab",
        "Fluid Mechanics Lab",
        "Manufacturing Processes",
        "Quality Control Systems",
      ],
      facultyHighlights: [
        {
          name: "Mr. Aphonce Kiio",
          expertise: "HoD Building & Civil Engineering ",
          photo: "/assets/images/hod-civil.jpg",
        },
      ],
      labEquipment: [
        "CNC Machines & Lathes",
        "CAD/CAM Workstations",
        "Materials Testing Equipment",
        "Robotics Training Kits",
      ],
    },
    {
      id: 3,
      name: "Electrical  & Electrinics Engineering",
      category: "EEE",
      duration: "Level 4, 5 & 6",
      level: "diploma",
      image: "/assets/images/Electrical_TraineesPractical5-min.JPG",
      icon: "Zap",
      description:
        "Comprehensive electrical engineering program covering power systems, electronics, and renewable energy.",
      fullDescription: `Our Electrical Engineering program provides comprehensive training in power generation, transmission, distribution, and utilization. Students learn about electrical machines, power electronics, control systems, and renewable energy technologies.\n\nThe program includes extensive laboratory work, industry visits, and hands-on projects. Students gain expertise in areas such as smart grids, electric vehicles, and sustainable energy systems.`,
      keyFeatures: [
        "Power Systems Laboratory",
        "Electrical Machines Lab",
        "Control Systems Lab",
        "Power Electronics Lab",
        "Renewable Energy Systems",
        "Smart Grid Technology",
        "Electric Vehicle Technology",
        "Industrial Automation",
      ],
      facultyHighlights: [
        {
          name: "Ms Kenjoy Kathure",
          expertise: "HoD Electrical & Electronics Engineering",
          photo: "/assets/images/hod-electrical.jpg",
        },
      ],
      labEquipment: [
        "Power System Simulators",
        "Electrical Machine Test Rigs",
        "Power Electronics Trainers",
        "Renewable Energy Lab Setup",
      ],
    },
    {
      id: 4,
      name: "Agriculture & Environmental Studies",
      category: "AES",
      duration: "Level 4, 5 & 6",
      level: "diploma",
      image: "/assets/images/FishPond_Farm-min.JPG",
      icon: "Leaf",
      description:
        "Comprehensive program in agriculture and environmental studies focusing on sustainable farming, ecological management, and environmental conservation.",
      fullDescription: `The Agriculture & Environmental Studies program at KTTI prepares students for careers in sustainable agriculture, environmental management, and ecological conservation. The curriculum covers crop science, soil management, environmental monitoring, sustainable farming practices, and climate change adaptation.\n\nStudents gain practical experience through fieldwork, laboratory testing, and real agricultural projects. The program emphasizes sustainable practices, biodiversity conservation, and modern agricultural technologies.`,
      keyFeatures: [
        "Crop Science Lab",
        "Soil Testing Lab",
        "Environmental Monitoring Lab",
        "Sustainable Farming Practices",
        "Biodiversity Conservation",
        "Climate Change Studies",
        "Agricultural Technology",
        "Ecological Management",
      ],
      facultyHighlights: [
        {
          name: "Mrs. Hannah Wahome",
          expertise: "HoD Agriculture & Environmental Studies",
          photo: "/assets/images/hod-agriculture.jpg",
        },
      ],
      labEquipment: [
        "Soil Testing Equipment",
        "Crop Analysis Tools",
        "Environmental Sensors",
        "Agricultural Machinery",
      ],
    },
    {
      id: 5,
      name: "Hospitality & Tourism",
      category: "IM",
      duration: "Level 4, 5 & 6",
      level: "diploma",
      image: "/assets/images/FoodServicePractical_2-min.JPG",
      icon: "Utensils",
      description:
        "Comprehensive program in hospitality services, tourism management, catering, and event management.",
      fullDescription: `The Hospitality & Tourism program at KTTI prepares students for careers in hotel management, institutional catering, event planning, and hospitality services. The curriculum covers food service operations, customer relations, event management, business administration, and hospitality industry standards.\n\nStudents gain practical experience through internships, culinary labs, and real hospitality projects. The program emphasizes customer service excellence, operational management, and modern hospitality technologies.`,
      studentsEnrolled: 350,
      keyFeatures: [
        "Culinary Arts Lab",
        "Event Management Studio",
        "Hospitality Operations",
        "Customer Service Training",
        "Food Safety & Hygiene",
        "Event Planning",
        "Business Administration",
        "Institutional Catering",
      ],
      facultyHighlights: [
        // { name: 'Dr. Sanjay Kumar', expertise: 'Communication Systems Expert' },
      ],
      labEquipment: [
        "Commercial Kitchen Equipment",
        "Hospitality Management Systems",
        "Food Preparation Tools",
      ],
    },
    {
      id: 6,
      name: "Cosmetology & Fashion Design",
      category: "CFD",
      duration: "Level 4, 5 & 6",
      level: "diploma",
      image: "/assets/images/Equipment2_Cosmetology-min.JPG",
      icon: "Scissors",
      description:
        "Comprehensive program in cosmetology and fashion design covering beauty services, fashion creation, and creative design techniques.",
      fullDescription: `The Cosmetology & Fashion Design program at KTTI prepares students for careers in the beauty and fashion industries. The curriculum covers cosmetology practices, fashion design principles, makeup artistry, hair styling, garment construction, and creative design techniques.\n\nStudents gain practical experience through hands-on labs, fashion shows, beauty demonstrations, and industry internships. The program emphasizes creativity, technical skills, and industry trends in both cosmetology and fashion design.`,
      studentsEnrolled: 350,
      keyFeatures: [
        "Cosmetology Lab",
        "Fashion Design Studio",
        "Makeup Artistry Training",
        "Hair Styling Techniques",
        "Garment Construction",
        "Fashion Illustration",
        "Beauty Product Knowledge",
        "Industry Trends & Innovation",
      ],
      facultyHighlights: [
        // { name: 'Dr. Sanjay Kumar', expertise: 'Communication Systems Expert' },
      ],
      labEquipment: [
        "Professional Sewing Machines",
        "Mannequins & Dress Forms",
        "Makeup Stations",
        "Hair Styling Tools",
        "Fashion Design Software",
        "Fabric Cutting Tables",
        "Cosmetology Chairs",
        "Beauty Product Storage",
      ],
    },
  ];

  // Filter departments based on current filters
  useEffect(() => {
    let filtered = departments;

    if (filters?.category !== "all") {
      filtered = filtered?.filter(
        (dept) => dept?.category === filters?.category
      );
    }

    if (filters?.duration !== "all") {
      filtered = filtered?.filter(
        (dept) => dept?.duration === filters?.duration
      );
    }

    if (filters?.level !== "all") {
      filtered = filtered?.filter((dept) => dept?.level === filters?.level);
    }

    if (filters?.search) {
      const searchTerm = filters?.search?.toLowerCase();
      filtered = filtered?.filter(
        (dept) =>
          dept?.name?.toLowerCase()?.includes(searchTerm) ||
          dept?.description?.toLowerCase()?.includes(searchTerm) ||
          dept?.keyFeatures?.some((feature) =>
            feature?.toLowerCase()?.includes(searchTerm)
          )
      );
    }

    setFilteredDepartments(filtered);
  }, [filters]);

  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      category: "all",
      duration: "all",
      level: "all",
      search: "",
    });
  };

  const openVirtualTour = (department) => {
    setSelectedDepartment(department);
    setIsVirtualTourOpen(true);
  };

  return (
    <>
      <Helmet>
        <title>KARUMO TECHNICAL TRAINING INSTITUTE</title>
        <meta
          name="description"
          content="Explore our comprehensive range of technical departments offering industry-relevant courses with state-of-the-art facilities and expert faculty."
        />
        <meta
          name="keywords"
          content="technical departments, engineering courses, computer science, mechanical engineering, electrical engineering, civil engineering, electronics, automobile engineering"
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        {/* Hero Section */}
        <section className="pt-24 pb-16 bg-gradient-to-br from-blue-600 via-background to-yellow-500">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center text-black mb-12">
              <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Icon name="GraduationCap" size={16} />
                <span>Academic Excellence</span>
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-2">
                Explore Our <span className="text-primary">Departments</span>
              </h1>
              <p className="text-xl text-black w-fit mx-auto leading-relaxed">
                Embark on a transformative journey of discovery and growth with
                our diverse range of technical and vocational programs. From
                cutting-edge computing and business technology, building and
                civil engineering, electrical and electronics engineering,
                sustainable agriculture and environmental studies, to
                hospitality and institutional management excellence, explore
                world-class education designed to shape your future with
                state-of-the-art facilities, expert faculty, and strong industry
                connections.
              </p>
            </div>

            {/* Quick Actions */}
            <div className="flex flex-wrap items-center justify-center gap-4 mb-8 ">
              <a href="/assets/files/brochure.pdf" download="KTTI_Brochure.pdf">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Download"
                  iconPosition="left"
                >
                  Download Brochure
                </Button>
              </a>

               <a href="/assets/files/feestructure.pdf" download="KTTI_Feestructure.pdf">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Download"
                  iconPosition="left"
                >
                  Download Fee Structure
                </Button>
              </a>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 bg-gradient-to-br from-blue-500 via-background to-yellow-500">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            {/* Filter Section */}
            <FilterSection
              filters={filters}
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
            />

            {/* Results Header */}
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl font-bold text-foreground mb-2">
                  {filteredDepartments?.length === departments?.length
                    ? "All Departments"
                    : `Filtered Results (${filteredDepartments?.length})`}
                </h2>
                <p className="text-muted-foreground">
                  {filteredDepartments?.length === 0
                    ? "No departments match your current filters. Try adjusting your search criteria."
                    : `Showing ${filteredDepartments?.length} of ${departments?.length} departments`}
                </p>
              </div>

              {filteredDepartments?.length > 0 && (
                <div className="flex items-center space-x-2">
                  <Icon
                    name="Grid3X3"
                    size={20}
                    className="text-muted-foreground"
                  />
                  <span className="text-sm text-muted-foreground">
                    Grid View
                  </span>
                </div>
              )}
            </div>

            {/* Departments Grid */}
            {filteredDepartments?.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
                {filteredDepartments?.map((department) => (
                  <DepartmentCard
                    key={department?.id}
                    department={department}
                    onVirtualTour={() => openVirtualTour(department)}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
                  <Icon
                    name="Search"
                    size={32}
                    className="text-muted-foreground"
                  />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  No Departments Found
                </h3>
                <p className="text-muted-foreground mb-6">
                  Try adjusting your filters or search terms to find relevant
                  departments.
                </p>
                <Button
                  variant="outline"
                  onClick={handleClearFilters}
                  iconName="RotateCcw"
                  iconPosition="left"
                >
                  Clear All Filters
                </Button>
              </div>
            )}
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-16 bg-gradient-to-r from-primary to-secondary">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Ready to Start Your Technical Journey?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Join thousands of successful graduates who started their careers
              at KTTI. Apply now and secure your future in hands-on technical
              courses.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  className="border-white text-white hover:bg-white hover:text-primary"
                >
                  Reach Out to Admissions
                </Button>
              
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Departments;
